import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, switchMap } from 'rxjs';
import { OpportunityLink } from '@/models/opportunity-link.model';
import { CreateOpportunityLinkDto } from '@/shared/dto/create-opportunity-link.dto';
import { UpdateOpportunityLinkDto } from '@/shared/dto/update-opportunity-link.dto';

@Injectable({ providedIn: 'root' })
export class OpportunityLinksService {
  private apiUrl = `${window.location.origin}/api/opportunity`;
  private linkApiUrl = `${window.location.origin}/api/opportunity-links`; // Separate URL for link-specific operations

  constructor(
    private http: HttpClient,
    private oidcSecurityService: OidcSecurityService
  ) {}

  getLinks(opportunityId: number): Observable<OpportunityLink[]> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.get<OpportunityLink[]>(`${this.apiUrl}/${opportunityId}/links`, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  createLink(opportunityId: number, dto: CreateOpportunityLinkDto): Observable<OpportunityLink> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.post<OpportunityLink>(`${this.apiUrl}/${opportunityId}/links`, dto, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  updateLink(linkId: number, dto: UpdateOpportunityLinkDto): Observable<OpportunityLink> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.patch<OpportunityLink>(`${this.linkApiUrl}/${linkId}`, dto, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  deleteLink(linkId: number): Observable<void> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.delete<void>(`${this.linkApiUrl}/${linkId}`, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }
}
